<template>
	<div class="layout-wrapper">
		<IntroSectionComp />
		<CalculatorSectionComp @result="priceResult = $event" />
		<WorkSectionComp />
		<StepsSectionComp />
		<MapSectionComp />
		<FeedbackSectionComp />
		<DeliverySectionComp :price="priceResult" />
	</div>
</template>

<script setup lang="ts">
const IntroSectionComp = defineAsyncComponent(
	() => import('@/components/IntroSection.vue')
);
const CalculatorSectionComp = defineAsyncComponent(
	() => import('@/components/CalculatorSection.vue')
);
const WorkSectionComp = defineAsyncComponent(
	() => import('@/components/WorkSection.vue')
);
const StepsSectionComp = defineAsyncComponent(
	() => import('@/components/StepsSection.vue')
);
const MapSectionComp = defineAsyncComponent(
	() => import('@/components/MapSection.vue')
);
const FeedbackSectionComp = defineAsyncComponent(
	() => import('@/components/FeedbackSection.vue')
);
const DeliverySectionComp = defineAsyncComponent(
	() => import('@/components/DeliverySection.vue')
);

const baseUrl = useRuntimeConfig().public.NUXT_PUBLIC_SITE_URL as string;

import { SEO } from '@/common/constants';
import type { ApiDeliveriesResult } from '@/common/types';

const priceResult = ref<ApiDeliveriesResult>();

useSeoMeta({
	title: SEO.title,
	description: SEO.description,
	ogTitle: SEO.title,
	ogDescription: SEO.description,
	ogImage: baseUrl + '/images/containers.png',
	ogUrl: baseUrl,
	ogType: 'website',
	ogSiteName: 'АПП - Агентство Правильных Перевозок',
	ogLocale: 'ru_RU',
	twitterCard: 'summary_large_image',
	twitterTitle: SEO.title,
	twitterDescription: SEO.description
});
</script>

<style scoped lang="scss">
.layout-wrapper {
	padding-bottom: 1.111rem;
}
</style>
